import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

import PageHeader from "../../components/common/PageHeader";
import TaskServices from "../../services/TaskServices";
import DataTable from "react-data-table-component";
import useTaskSubmit from "../../hooks/useTaskSubmit";
import Error from "../../components/Input/Error";
import DropdownServices from "../../services/DropdownServices";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import { useLocation } from "react-router-dom";
import DropDownService from "../../services/DropDownService";
import moment from "moment/moment";

function Tasks() {
  const [rowData, setrowData] = useState([]);
  const [columnsT, setcolumnT] = useState([]);
  const [EmployeeData, setEmployeeData] = useState([]);
  const [ProjectData, setProjectData] = useState([]);
  // const [startDatemandetory, setStartDatemandetory] = useState("");
  const [taskID, settaskID] = useState("");
  // const [loadings, setLoading] = useState(true); // loading state
  const { data, loading } = useAsync(() => TaskServices?.getAllTask());
  const location = useLocation();
  const { pathname } = location;

  const { data: permissionData } = useAsync(() =>
    DropDownService.getModulePermissions({
      path: pathname,
      userId: localStorage.id,
    })
  );
  var addPermission =
    typeof permissionData?.data?.add === "undefined"
      ? 1
      : permissionData?.data?.add;
  var viewPermission =
    typeof permissionData?.data?.view === "undefined"
      ? 1
      : permissionData?.data?.view;
  var editPermission =
    typeof permissionData?.data?.edit === "undefined"
      ? 1
      : permissionData?.data?.edit;
  var deletePermission =
    typeof permissionData?.data?.delete === "undefined"
      ? 1
      : permissionData?.data?.delete;
  var listPermission =
    typeof permissionData?.data?.list === "undefined"
      ? 1
      : permissionData?.data?.list;
  const {
    register,
    onSubmit,
    handleSubmit,
    deleteTask,
    ShowEditValues,
    errors,
    isViewModal,
    setIsViewModal,
    viewData,
    isModal,
    setIsModal,
    isDeleteModal,
    setIsDeleteModal,
    startDatemandetory,
    setStartDatemandetory,
    reset,
  } = useTaskSubmit(taskID);

  useEffect(() => {
    const getEndDate = (rowData) => {
      const taskLog = rowData?.taskLog; // Access taskLog from rowData
      const taskLogLength = taskLog?.length ?? 0; // Get the length safely
      // Check if taskLog has more than 1 entry
      if (rowData.taskStatus == "Completed") {
        return moment
          .utc(taskLog[taskLogLength - 1]?.startTime)
          .format("DD-MM-YYYY HH:mm");
      } else {
        return "-";
      }
    };
    const getStartDate = (rowData) => {
      const taskLog = rowData?.taskLog; // Access taskLog from rowData
      const taskLogLength = taskLog?.length ?? 0; // Get the length safely
      // Check if taskLog has more than 1 entry
      if (rowData?.taskStartDate == null) {
        return moment.utc(taskLog[0]?.startTime).format("DD-MM-YYYY HH:mm"); // Default value if condition is not met
      } else {
        return moment.utc(rowData?.taskStartDate).format("DD-MM-YYYY HH:mm"); // Default value if condition is not met
      }
    };
    const getAllTasks = async (result) => {
      var rowData = result?.data;
      var taskLog = rowData?.taskLog;
      setrowData(rowData);
      var columnT = "";
      columnT = [
        {
          name: "S.No.",
          selector: (_, index) => index + 1,
          sortable: true,
        },
        {
          name: "PROJECT NAME",
          selector: (rowData) => rowData?.projectId?.projectName,
          sortable: true,
        },
        {
          name: "PROJECT MODULE",
          selector: (rowData) => rowData?.projectModule,
          sortable: true,
        },
        {
          name: "TASK",
          selector: (rowData) => rowData?.tasks[0],
          sortable: true,
        },
        {
          name: "ASSIGNED PERSON",
          selector: (rowData) => rowData?.assignPerson?.employeeName,
          sortable: true,
        },
        {
          name: "START DATE",
          selector: (rowData) => getStartDate(rowData),
          sortable: true,
        },
        {
          name: "END DATE",
          selector: (rowData) => getEndDate(rowData),
          sortable: true,
        },
        {
          name: "STATUS",
          selector: (rowData) => rowData?.taskStatus,
          sortable: true,
          cell: (row) => (
            <span
              className={`badge ${
                row.taskStatus === "Completed"
                  ? "bg-success"
                  : row.taskStatus === "Hold"
                  ? "bg-danger"
                  : row.taskStatus === "Open"
                  ? "bg-primary"
                  : "bg-warning"
              }`}
            >
              {row.taskStatus}
            </span>
          ),
        },
        {
          name: "ACTION",
          selector: (rowData) => {},
          sortable: true,
          cell: (rowData) => (
            <div
              className="btn-group"
              role="group"
              aria-label="Basic outlined example"
            >
              {viewPermission === 1 && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => {
                    setIsViewModal(true);
                    ShowEditValues(rowData, "View");
                    settaskID(rowData?._id);
                  }}
                >
                  <i className="icofont-eye-alt text-primary"></i>
                </button>
              )}
              {editPermission === 1 && (
                <button
                  className="btn btn-outline-secondary"
                  data-bs-toggle="modal"
                  data-bs-target="#depedit"
                  onClick={() => {
                    setIsModal(true);
                    ShowEditValues(rowData, "Edit");
                    settaskID(rowData?._id);
                    reset();
                  }}
                >
                  <i className="icofont-edit text-success"></i>
                </button>
              )}
              {deletePermission === 1 && (
                <button
                  className="btn btn-outline-secondary deleterow"
                  onClick={() => {
                    setIsDeleteModal(true);
                    settaskID(rowData?._id);
                  }}
                >
                  <i className="icofont-ui-delete text-danger"></i>
                </button>
              )}
            </div>
          ),
        },
      ];
      setcolumnT(columnT);
      // console.log(" columnT ==", columnT);
    };

    const getEmpDropdownData = async () => {
      const result = await DropdownServices.getEmployeeDropdown();
      setEmployeeData(result);
    };

    const getProjectDropdownData = async () => {
      const result = await DropdownServices.getProjectDropdown();
      setProjectData(result);
    };

    setTimeout(() => {
      getAllTasks(data);
    }, 100);
    getEmpDropdownData();
    getProjectDropdownData();
  }, [data]);

  return (
    <div className="container-xxl">
      <PageHeader
        headerTitle="Tasks"
        addPermission={addPermission}
        renderRight={() => {
          return (
            <div className="col-auto d-flex w-sm-100">
              <button
                className="btn btn-dark btn-set-task w-sm-100"
                onClick={() => {
                  setIsModal(true);
                  settaskID("");
                  reset();
                }}
              >
                <i className="icofont-plus-circle me-2 fs-6"></i>Add Tasks
              </button>
            </div>
          );
        }}
      />
      {listPermission === 1 && (
        <div className="row clearfix g-3">
          <div className="col-sm-12">
            <DataTable
              title="Task"
              columns={columnsT}
              data={rowData}
              defaultSortField="title"
              pagination
              selectableRows={false}
              className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
              highlightOnHover={true}
              progressPending={loading}
              progressComponent={<ModalLoading loading={loading} />}
            />
          </div>
        </div>
      )}

      <Modal
        show={isModal}
        size="lg"
        onHide={() => {
          setIsModal(false);
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Create Task</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label htmlFor="projectId" className="form-label">
                Project Name
              </label>
              <select
                className="form-select"
                name="projectId"
                {...register(`projectId`, {
                  required: `Project Name is required!`,
                })}
              >
                <option value="">Select Project Name</option>
                {ProjectData?.data?.map((category, idx) => (
                  <option key={idx} value={category?.value}>
                    {category?.label}
                  </option>
                ))}
              </select>
              <Error errorName={errors?.projectId} />
            </div>
            <div className="mb-3">
              <label className="form-label">Project Module</label>
              <input
                type="text"
                className="form-control"
                name="projectModule"
                id="projectModule"
                {...register(`projectModule`, {
                  required: `Project Module is required!`,
                })}
              />
              <Error errorName={errors?.projectModule} />
            </div>
            <div className="mb-3">
              <label className="form-label">Task</label>
              <input
                type="text"
                className="form-control"
                name="tasks.0"
                id="tasks"
                {...register(`tasks.0`, { required: `Task is required!` })}
              />
              <Error errorName={errors?.tasks?.[0]} />
            </div>
            <div className="mb-3">
              <label htmlFor="description" className="form-label">
                Task Description
              </label>
              <textarea
                className="form-control"
                name="description"
                id="description"
                {...register(`description`)}
                rows="3"
                placeholder="Add any extra details about the request"
              ></textarea>
            </div>
            <div className="deadline-form">
              <div className="row g-3 mb-3">
                {taskID && startDatemandetory !== "Open" && (
                  <div className="col">
                    <label htmlFor="taskStartDate" className="form-label">
                      Task Start Date
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="taskStartDate"
                      name="taskStartDate"
                      {...register(`taskStartDate`, {
                        required:
                          startDatemandetory === "Open" || !taskID
                            ? false
                            : "Start Date is Required",
                      })}
                    />
                    <Error errorName={errors?.taskStartDate} />
                  </div>
                )}
                {taskID && startDatemandetory === "Completed" && (
                  <div className="col">
                    <label htmlFor="taskEndDate" className="form-label">
                      Task End Date
                    </label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="taskEndDate"
                      name="taskEndDate"
                      {...register(`taskEndDate`, {
                        required:
                          startDatemandetory !== "Completed" || !taskID
                            ? false
                            : "End Date is Required",
                      })}
                    />
                    <input
                      type="hidden"
                      name="notification"
                      id="notification"
                      value="All"
                      {...register(`notification`)}
                    />
                    <Error errorName={errors?.taskEndDate} />
                  </div>
                )}
              </div>
              <div className="row g-3 mb-3">
                <div className="col">
                  <label htmlFor="assignPerson" className="form-label">
                    Task Assign Person
                  </label>
                  <select
                    className="form-select"
                    name="assignPerson"
                    {...register(`assignPerson`, {
                      required: `Task Assign Person is required!`,
                    })}
                  >
                    <option value="">Select Task Assign Person</option>
                    {EmployeeData?.data?.map((category, idx) => (
                      <option key={idx} value={category?.value}>
                        {category?.label}
                      </option>
                    ))}
                  </select>
                  <Error errorName={errors?.assignPerson} />
                </div>
                <div className="col">
                  <label htmlFor="formFileMultipleone" className="form-label">
                    Priority
                  </label>
                  <select
                    className="form-select"
                    name="priority"
                    id="priority"
                    {...register(`priority`, {
                      required: `Priority is required!`,
                    })}
                  >
                    <option value="">Select Priority</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </select>
                  <Error errorName={errors?.priority} />
                </div>
              </div>
              <div className="row g-3 mb-3">
                <div className="col">
                  <label htmlFor="formFileMultipleone" className="form-label">
                    Task Status
                  </label>
                  <select
                    className="form-select"
                    name="taskStatus"
                    id="taskStatus"
                    {...register(`taskStatus`)}
                    onChange={(e) => setStartDatemandetory(e.target.value)}
                  >
                    {!taskID ? (
                      <option value="Open">Open</option>
                    ) : (
                      <>
                        {viewData?.taskStatus === "Open" && (
                          <option value="Open">Open</option>
                        )}
                        <option value="In Progress">In Progress</option>
                        <option value="Hold">Hold</option>
                        <option value="Completed">Completed</option>
                        <option value="Re-Open">Re-Open</option>
                      </>
                    )}
                  </select>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setIsModal(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              {taskID ? "Update " : "Add"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        centered
        show={isViewModal}
        size="lg"
        onHide={() => {
          setIsViewModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">View Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="deadline-form">
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Project Name : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.projectId?.projectName}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Project Module : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.projectModule}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.tasks?.[0]}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task Description : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.description || "-"}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task Start Date : </b>
              </div>
              <div className="col-sm-6">
                <div>
                  {viewData?.taskStartDate
                    ? moment
                        .utc(viewData?.taskStartDate)
                        .format("DD-MM-YYYY HH:mm")
                    : "-"}
                </div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task End Date : </b>
              </div>
              <div className="col-sm-6">
                <div>
                  {viewData?.completedDate
                    ? moment
                        .utc(viewData?.completedDate)
                        .format("DD-MM-YYYY HH:mm")
                    : "-"}
                </div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task Assign Person : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.assignPerson?.employeeName}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Priority : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.priority}</div>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <b> Task Status : </b>
              </div>
              <div className="col-sm-6">
                <div>{viewData?.taskStatus}</div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Task delete modal */}
      <Modal
        show={isDeleteModal}
        centered
        onHide={() => {
          setIsDeleteModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">Delete Schedule</Modal.Title>
        </Modal.Header>
        <Modal.Body className="justify-content-center flex-column d-flex">
          <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
          <p className="mt-4 fs-5 text-center">
            Are You Sure! Want to Delete Task?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              setIsDeleteModal(false);
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger color-fff"
            onClick={() => deleteTask(taskID)}
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Tasks;
